const TABLE_COLUMNS = [
  {
    name: 'name',
    icon: 'el-icon-document',
    sortable: false,
  },
  {
    name: 'quantity',
    label: 'Qty',
    icon: 'el-icon-document',
    width: 50,
    sortable: false,
  },
  {
    name: 'totalValue',
    label: 'Amount',
    format: value => {
      return `$${value}`
    },
    icon: 'el-icon-document',
    width: 70,
    sortable: false,
  },
]

export default component => ({
  processor: null,
  columns: TABLE_COLUMNS,
  tableName: 'claim-order',
})
